import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as EditTemplateActions from './edit-template-store.action';
import { DocumentTypeSettingsActions } from './edit-template-store.action';
import * as EditTemplateSelectors from './edit-template-store.selector';

@Injectable({ providedIn: 'root' })
export class EditTemplateFacade {

  template$ = this.store.select(EditTemplateSelectors.selectTemplate);
  loading$ = this.store.select(EditTemplateSelectors.selectLoading);
  templateRoute$ = this.store.select(EditTemplateSelectors.selectTemplateRoute);

  constructor(private store: Store) {}

  loadTemplate(id: string, route: string) {
    this.store.dispatch(EditTemplateActions.loadTemplate({ id, route }));
  }

  updateDocumentTypeGroups(id: number) {
    this.store.dispatch(DocumentTypeSettingsActions.changeDocumentType({ id }));
  }

  setTemplateRoute(id: number, route: string) {
    this.store.dispatch(EditTemplateActions.setTemplateRoute({ routeState: { id, route } }));
  }

  clearTemplateState(){
    this.store.dispatch(EditTemplateActions.clearState())
  }

}
